
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Language detector with custom logic for regional variants
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'customDetector',
  lookup() {
    // Try localStorage first
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang && ['en', 'es-CL'].includes(storedLang)) {
      return storedLang;
    }

    // Get browser language
    const browserLang = navigator.language || navigator.languages?.[0];

    // Map regional variants to supported languages
    if (browserLang) {
      // Spanish variants → es-CL
      if (browserLang.startsWith('es')) {
        return 'es-CL';
      }
      // English variants → en
      if (browserLang.startsWith('en')) {
        return 'en';
      }
    }

    // Default fallback
    return 'en';
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  }
});

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es-CL'],
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Cache-busting: Increment version when translations change
      // This forces browser to reload translation files instead of using stale cache
      queryStringParams: { v: '41' },
    },

    detection: {
      order: ['customDetector', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    ns: [
      'common',
      'auth',
      'dashboard',
      'tenantSetup',
      'tenantAdmin',
      'errors',
      'conversations',
      'workflows',
      'products',
      'platformAdmin',
      'validation',
      'notifications',
      'contextStores',
      'analytics',
      'templates',
      'aiAssistant',
      'settings',
      'customExtensions',
      'onboarding',
      'userManagement',
      'whatsappConfig',
      'payments',
      'customers',
      'orders',
      'documentReview',
      'documentTypes',
      'appStudio',
      'data-source-picker',
      'runObservability',
      'testingSuite',
      'conversationTesting',
      'conversationSimulator',
      'tenantTestEnvironment',
      'flowSweep',
      'spaceWizard',
      'businessHours',
      'library',
      'credentials',
      'businessRules',
      'rehearsalEnvironment',
      'formLinks'
    ],
    defaultNS: 'common',
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

export default i18n;
